// Eventos da paleta de comandos que pertencem ao CRM (2026-08-08).
//
// Vivem em arquivo NOSSO, e não em `dashboard/helper/commandbar/events.js`, porque aquele é
// do upstream: cada linha adicionada lá é um conflito por merge para sempre. Aqui não
// custa nada e diz de quem é a coisa.
export const CMD_CRM_MARCAR_GANHO = 'CMD_CRM_MARCAR_GANHO';
export const CMD_CRM_MARCAR_PERDA = 'CMD_CRM_MARCAR_PERDA';
